export const filtersReducer = (state = null, action) => {
    switch (action.type) {
        case "UPDATE_OPERATOR":
            return state
                ? {
                    ...state,
                    operation: action.payload,
                }
                : null;
        case "UPDATE_VALUE":
            return state
                ? {
                    ...state,
                    values: action.payload,
                }
                : null;
        case "SELECT_FILTER":
            return action.payload;
        case "RESET_FILTER":
            return null;
        default:
            return state;
    }
};
//# sourceMappingURL=reducer.js.map